var React = require('react');

function LuxeCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.3125 6.79407L6.04148 10.5527L15.6875 1.18744","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round"}));
}

LuxeCheck.defaultProps = {"width":"17","height":"12","viewBox":"0 0 17 12","fill":"none"};

module.exports = LuxeCheck;

LuxeCheck.default = LuxeCheck;
